module.exports = __webpack_public_path__ + "static/media/col-women.d48a3fbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/col-women.jpg
// module id = 1119
// module chunks = 33